import * as api from '@/api/category'
import Category from '@/store/models/category'

export let state = {
  category: new Category,
  categories: {
    data: []
  },
  categoryList: []
}

export let mutations = {
  setCategories: (state, payload) => state.categories = payload,
  setCategoryList: (state, payload) => state.categoryList = payload,

  reset: state => state.category = new Category,
  setCategory: (state, payload) => state.category = (new Category).hydrate(payload),
  setTitle: (state, payload) => state.category.title = payload,
  setSlug: (state, payload) => state.category.slug = payload,
  setType: (state, payload) => state.category.type = payload
}

export let actions = {

  paginate: ({ commit }, path) => new Promise((resolve, reject) => {
    api.paginate(path, response => {
      commit('setCategories', response.data)
      resolve()
    }, reject)
  }),

  listByType: ({ commit }, type) => new Promise((resolve, reject) => {
    api.listByType(type, response => {
      commit('setCategoryList', response.data)
      resolve()
    }, reject)
  }),

  load: ({ commit }, category) => new Promise((resolve, reject) => {
    api.load(category, response => {
      commit('setCategory', response.data)
      resolve()
    }, reject)
  }),

  create: ({ state, commit }, type = '') => new Promise((resolve, reject) => {
    api.create(state.category, type, () => {
      commit('reset')
      resolve()
    }, reject)
  }),

  save: ({ state, commit }) => new Promise((resolve, reject) => {
    api.save(state.category, () => {
      commit('reset')
      resolve()
    }, reject)
  }),

  remove: ({ }, category) => new Promise((resolve, reject) => {
    api.remove(category.id, resolve, reject)
  })

}

